// extracted by mini-css-extract-plugin
export default {"mainSection":"SignInForm_mainSection__nyTXl"};